export function readDeskColors() {
  if (typeof document === 'undefined') {
    return {
      bg: '#0B0E14',
      surface: '#151924',
      hover: '#1E2330',
      text: '#E8EDF7',
      muted: '#8B93A7',
      bull: '#3DDC97',
      bear: '#F07167',
      action: '#6C8CFF',
      candleUp: '#3DDC97',
      candleDown: '#F07167',
      grid: 'rgba(255,255,255,0.04)',
    };
  }
  const s = getComputedStyle(document.documentElement);
  const v = (name, fallback) => {
    const n = s.getPropertyValue(name).trim();
    return n || fallback;
  };
  return {
    bg: v('--lt-bg', '#0B0E14'),
    surface: v('--lt-surface', '#151924'),
    hover: v('--lt-hover', '#1E2330'),
    text: v('--lt-text', '#E8EDF7'),
    muted: v('--lt-muted', '#8B93A7'),
    bull: v('--lt-bull', '#3DDC97'),
    bear: v('--lt-bear', '#F07167'),
    action: v('--lt-action', '#6C8CFF'),
    candleUp: v('--lt-candle-up', v('--lt-bull', '#3DDC97')),
    candleDown: v('--lt-candle-down', v('--lt-bear', '#F07167')),
    grid: v('--lt-grid', 'rgba(255,255,255,0.04)'),
  };
}

export function withAlpha(color, alpha) {
  const c = String(color || '').trim();
  if (c.startsWith('#') && (c.length === 7 || c.length === 4)) {
    const hex = c.length === 4
      ? `#${c[1]}${c[1]}${c[2]}${c[2]}${c[3]}${c[3]}`
      : c;
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r},${g},${b},${alpha})`;
  }
  return c;
}
